<template>
  <hic-list-page :title="tabTitle" :entities="entities" :condition="condition" @load="page" keyword-placeholder="患者姓名" :loading="meta.loading" header-height="6rem">
    <template slot="buttons">
      <!-- <el-button type="primary" size="small" icon="el-icon-money" @click="create">
        <span v-if="tabName == 'deposit'">缴费</span>
        <span v-if="tabName == 'ious'">申请</span>
      </el-button> -->
    </template>
    <template slot="search">
      <el-date-picker @change="dateChange" style="width: 270px" size="small" v-model="condition.date" type="daterange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束日期"> </el-date-picker>
    </template>
    <template slot="extend">
      <el-tabs v-model="tabName" @tab-click="page">
        <el-tab-pane label="预交金" name="deposit"> </el-tab-pane>
        <el-tab-pane label="打白条" name="ious"> </el-tab-pane>
      </el-tabs>
    </template>

    <el-table-column v-if="tabName == 'deposit'" align="center" width="80" label="操作" key="depositCmd">
      <template slot-scope="{ row }">
        <el-button title="打印" type="primary" plain size="mini" circle icon="el-icon-printer" @click="inEdtior(row, true)"></el-button>
      </template>
    </el-table-column>
    <el-table-column v-if="tabName == 'ious'" align="center" label="操作" width="150" key="iousCmd">
      <template slot-scope="{ row }">
        <el-button v-if="row.state == '草稿' || row.state == '审批中' || row.state == '拒绝'" title="删除" type="danger" size="mini" plain icon="el-icon-delete" circle @click="delQZ(row.id)"></el-button>
        <el-button v-if="row.state == '草稿' || row.state == '拒绝'" title="编辑" type="primary" size="mini" plain icon="el-icon-edit" circle @click="withdraw(row, '欠账编辑')"></el-button>
        <el-button v-if="row.state == '审批中' && row.proposerId != user.id" title="审批" type="primary" size="mini" plain icon="el-icon-coordinate" circle @click="withdraw(row, '欠账审批')"></el-button>
        <!-- <el-button type="primary" size="mini" icon="el-icon-coordinate" circle @click="withdraw(row,'欠账审批')"></el-button> -->

        <el-button v-if="row.state == '审批中' || row.state == '通过'" title="详情" type="info" plain size="mini" icon="el-icon-search" circle @click="withdraw(row, '欠账详情')"></el-button>
      </template>
    </el-table-column>
    <el-table-column v-if="tabName == 'deposit'" align="center" label="流水号" prop="no" key="no" width="140"> </el-table-column>

    <!-- <el-table-column align="center" width="100px;" column-key="deptCode" :filters="dict.Dept" :filter-multiple="true" label="住院科室" prop="deptCode">
      <template slot-scope="{ row }"> {{ row.deptCode | dictText("Dept") }} </template>
    </el-table-column>
    <el-table-column align="center" label="住院病区" prop="wardCode" width="120px">
      <template slot-scope="{ row }"> {{ row.wardCode | dictText("IpWard") }} </template>
    </el-table-column> -->
    <el-table-column v-if="tabName == 'deposit'" column-key="type" :filters="dictEnum.DepositType" :filter-multiple="false" align="center" label="类型" prop="type" key="type" width="80">
      <template #default="{ row }">
        <el-tag v-if="row.type == '收费'" type="success" hit size="small">{{ row.type }}</el-tag>
        <el-tag v-if="row.type == '退费'" type="danger" hit size="small">{{ row.type }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column v-if="tabName == 'deposit'" align="right" width="130" label="金额" prop="amount" key="amount">
      <template slot-scope="{ row }">
        <span class="danger">{{ row.amount | fmtFloat(2) }}</span>
      </template>
    </el-table-column>

    
    <el-table-column v-if="tabName == 'ious'" column-key="state" :filters="dictEnum.IousAuditState" :filter-multiple="false" :filter-value="['通过']"  align="center" width="100" label="状态" prop="state" key="state" mutiple>
      <template slot-scope="{ row }"> 
        <el-tag v-if="row.state=='通过'" type="success" size="small" hit>{{ row.state }}</el-tag> 
        <el-tag v-else-if="row.state='驳回'" type="danger" size="small" hit>{{ row.state }}</el-tag> 
        <el-tag v-else type="warning" size="small" hit>{{ row.state }}</el-tag> 
      </template>
    </el-table-column>
    <el-table-column v-if="tabName == 'ious'" align="right" sortable="custom" label="白条额度" prop="amount" key="iousAmount"> 
      <template #default="{row}">
        <span class="danger">{{ row.amount | fmtFloat(2) }}</span>
      </template>
    </el-table-column>
    <el-table-column v-if="tabName == 'ious'" align="center" sortable="custom" width="120" label="到期时间" prop="endDate" key="endDate">
      <template #default="{ row }">
        <el-tag v-if="$utils.Dt.isEarlier(row.endDate, $utils.Dt.now())"  type="warning" size="small" hit effect="plain">{{ row.endDate | fmtDate }}</el-tag>
        <span v-else>{{ row.endDate | fmtDate }}</span>
      </template>
    </el-table-column>

    <el-table-column label="患者姓名" prop="patientName" key="patientName">
      <template #default="{ row }">
        <b>{{ row.patientName }}</b>
      </template>
    </el-table-column>
    <el-table-column label="住院号" prop="ipNo" width="150" key="ipNo"> </el-table-column>
    <el-table-column v-if="tabName == 'deposit'" align="center" label="时点" prop="occasion" key="occasion"></el-table-column>
    <el-table-column v-if="tabName == 'deposit'" label="交款人" prop="payerName" key="payerName"> </el-table-column>
    <el-table-column v-if="tabName == 'deposit'" label="收款人" prop="operator" key="operator"> </el-table-column>
    <el-table-column v-if="tabName == 'deposit'" align="center" width="120" column-key="payWay" :filters="dict.PayWay" :filter-multiple="false" label="收款方式" prop="payWay" key="payWay">
      <template slot-scope="{ row }">
        <div>{{ row.payWay | dictText("PayWay") }}</div>
      </template>
    </el-table-column>
    <el-table-column v-if="tabName == 'deposit'" align="center" label="收款时间" prop="paymentDate" width="160" key="paymentDate"> </el-table-column>




    <el-table-column v-if="tabName == 'ious'" align="center" label="申请人" prop="createUserName" key="createUserName"> </el-table-column>
    <!-- <el-table-column align="center" sortable="custom" width="140px;" label="申请时间" prop="proposeTime"> </el-table-column> -->
    <el-table-column v-if="tabName == 'ious'" align="center" sortable="custom" width="100" label="申请日期" prop="createDate" key="createDate">
      <template #default="{ row }">
        {{ row.createDate | fmtDate }}
      </template>
    </el-table-column>
    <el-table-column v-if="tabName == 'ious'" align="center" sortable="custom" width="100" label="审批日期" prop="auditTime" key="auditTime">
      <template #default="{ row }">
        {{ row.auditTime | fmtDate }}
      </template>
    </el-table-column>
    <el-table-column v-if="tabName == 'ious'" align="center" label="审批人" prop="auditorName" key="auditorName"> </el-table-column>

    <el-table-column v-if="tabName == 'reminder'" align="right" width="120px" sortable="custom" label="预交总额" prop="depositAmount" key="depositAmount"> </el-table-column>
    <el-table-column v-if="tabName == 'reminder'" align="right" width="120px" sortable="custom" label="记账金额" prop="bookkeepingFeeTotal" key="bookkeepingFeeTotal"> </el-table-column>

    <pay v-if="meta.showPay" title="欠账申请" :infoDetail="JSON.parse(JSON.stringify(selInfo))" :visible.sync="meta.showPay" @close="page"></pay>
    <daily v-if="meta.showDaily" :title="title" :visible.sync="meta.showDaily"></daily>
    <operation v-if="meta.showOper" title="退预交金" :visible.sync="meta.showOper"></operation>
  </hic-list-page>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      pay: () => import("./pay"),
      daily: () => import("./daily"),
      operation: () => import("./operation"),
    },
    data() {
      return {
        tabName: "deposit",
        title: "",
        meta: {
          showOper: false,
          showDaily: false,
          showPay: false,
          loading: false,
        },
        selInfo: {},
        condition: {
          date: null,
          keyword: null,
          pageSize: 20,
          pageIndexOnView: 1,
          sort: "id",
          asc: false,
        },
        entities: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
      tabTitle() {
        switch (this.tabName) {
          case "deposit":
            return "预交金";
          case "ious":
            return "打白条";
          default:
            return "缴费提醒";
        }
      },
    },
    methods: {
      create() {},
      withdraw(info) {
        this.meta.showPay = true;
      },
      dateChange(v) {
        let btitme = v ? utils.fmtDateTime(v[0]) : "";
        let etime = v ? utils.fmtDateTime(v[1]) : "";

        if (this.tabName == "reminder") {
          this.condition.startDateSt = btitme;
          this.condition.startDateEd = etime;
        } else if (this.tabName == "ious") {
          this.condition.proposeTimeSt = btitme;
          this.condition.proposeTimeEd = etime;
        } else {
          this.condition.paymentDateSt = btitme;
          this.condition.paymentDateEd = etime;
        }

        this.page();
      },
      conditionFn(info) {
        let type = Array.isArray(info);
        if (type) {
          this.condition.ipOrderModels = info;
        } else {
          this.condition = Object.assign(this.condition, info);
        }
        this.page();
      },
      page() {
        this.meta.loading = true;
        try {
          switch (this.tabName) {
            case "deposit":
              // let params = JSON.parse(JSON.stringify(this.condition))
              // params.patientName = params.keyword
              // delete params.keyword
              api
                .getDepositList(this.condition)
                .then((res) => {
                  this.entities = res;
                })
                .catch((err) => {
                  this.$message.error(err.message || err);
                })
                .finally(() => {
                  this.meta.loading = false;
                });
              break;
            case "reminder":
              this.condition.state = "已入住";
              api
                .getRemindList(this.condition)
                .then((res) => {
                  this.entities = res;
                })
                .catch((err) => {
                  this.$message.error(err.message || err);
                })
                .finally(() => {
                  this.meta.loading = false;
                });
              break;
            case "ious":
              // delete this.condition.state;
              this.condition.ifDeleted = false;
              this.meta.loading = false;
              api
                .getQZ(this.condition)
                .then((res) => {
                  this.entities = res;
                })
                .catch((err) => {
                  this.$message.error(err.message || err);
                })
                .finally(() => {
                  this.meta.loading = false;
                });
              break;
          }
        } catch (err) {
          if (err && err != "cancel") {
            console.log(err);
            this.$message.error(err.message || err);
          }
        }
      },
      inDetail(row) {
        this.selInfo = row;
        this.meta.showPay = true;
      },
    },
  };
</script>

<style scoped>
  .redaK {
    margin-left: 1rem;
    background-color: #909399;
  }
  .wedge-left {
    margin-left: 5px;
  }
  .condition-wide {
    width: 17rem;
  }
  .el-tag--dark {
    border-color: rgba(0, 0, 0, 0);
  }
  .tofvoer {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>
